import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {map, Observable} from 'rxjs';


@Injectable()
export class ResponseHeadersInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.includes('download')) {
            request = request.clone({ responseType: 'blob' });
            return next.handle(request).pipe(
                map((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        const contentDisposition = event.headers.get('Content-Disposition');
                        //contentDisposition = 'attachment; filename=2023-10-11-export-rating.xlsx';

                        // @ts-ignore
                        const filenameMatch = /filename\*?=['"]?([^;'"]+)['"]?;?/.exec(contentDisposition);
                        if (filenameMatch) {
                            (event as any).body.name = filenameMatch[1];
                        }
                    }
                    return event;
                })
            );
        } else {
            return next.handle(request);
        }
    }
}
